module.exports = __webpack_public_path__ + "static/work-home-1e484ba49cd25c593a202d8e88cd2ed6.png";